import i18n from '../../../i18n';

export const PENDING_QUOTATION = 'pending_quotation';
export const PENDING_CUSTOMER_CONFIRMATION = 'pending_customer_confirmation';
export const PENDING_CUSTOMER_INFORMATION = 'pending_customer_information';
export const ACCEPTED = 'accepted';
export const REJECTED = 'rejected';
export const DRAFT = 'draft';

const names = {
    [PENDING_QUOTATION]: 'booking.status_pending_quotation',
    [PENDING_CUSTOMER_CONFIRMATION]: 'booking.status_pending_customer_confirmation',
    [PENDING_CUSTOMER_INFORMATION]: 'booking.status_pending_customer_information',
    [ACCEPTED]: 'booking.status_quotation_accepted',
    [REJECTED]: 'booking.status_quotation_rejected',
    [DRAFT]: 'booking.status_quotation_draft'
};

export const selectOptions = [
    {
        value: PENDING_QUOTATION,
        label: statusName(PENDING_QUOTATION)
    },
    {
        value: PENDING_CUSTOMER_CONFIRMATION,
        label: statusName(PENDING_CUSTOMER_CONFIRMATION)
    },
    {
        value: ACCEPTED,
        label: statusName(ACCEPTED)
    },
    {
        value: REJECTED,
        label: statusName(REJECTED)
    },
    {
        value: PENDING_CUSTOMER_INFORMATION,
        label: statusName(PENDING_CUSTOMER_INFORMATION)
    },
    {
        value: DRAFT,
        label: statusName(DRAFT)
    }
];

export function statusName(type) {
    return i18n.t(names[type]);
}
